// Owner Request Page — wrapper for the multi-step form
import { PageHeader } from "@/components/shared";
import { OwnerRequestForm } from "@/components/owner/OwnerRequestForm";

export function OwnerRequestPage() {
  return (
    <div>
      <PageHeader
        title="Anonymous Owner Request"
        description="Tell agents about your property — your identity stays private."
      />
      <OwnerRequestForm />
    </div>
  );
}
